import { ENV, ENV_HACKERONE, ENV_DEV_OR_STAGING } from './helpers/environment'

const config = {
	development: {
		Auth0Domain: 'auth.dev.fstr.app',
		Auth0ClientId: 'GiDHEn35LI0JH4aZAL4iBRNPMlIu9dnR',
		Auth0AudienceDomain: 'https://rest.dev.fstr.app',
		AbSmartlyApiHost: import.meta.env.VITE_ABSMARTLY_API_HOST || 'https://simple.absmartly.io',
		AbSmartlyApiKey: '2HkWTYAWpZGDabCrX_Dx4gAJpw-CF5j4QcZXLSSKxCpclQmido5k7qKMuZuu70zd',
		AmplitudePaltaWeb: '2f3a8a3d04de1a14bb085afc5d21258d',
		GTMMainContainer: 'GTM-MZ8NBTM',
		GTMActivityContainer: 'GTM-MZ8NBTM',
		GTMGLP1Container: 'GTM-MZ8NBTM',
		OnetrustSimpleLifeAppApiKey: 'f408777c-6bdf-4ff7-bfc6-6bdea2869b6e-test',
		OnetrustSimpleLifeApiKey: 'c264de99-8404-4220-bdb5-5d66776eeda0-test',
		BrazeApiKey: 'f164faaf-179f-4102-83d8-8638a0d78f0a',
		BrazeCanvasApiKey: '09f74117-f3b2-492f-a0a8-1c35c6ecc4a0',
		BrazeCampaignApiKey: 'ddbfa2c2-1912-403b-97b1-5db8a6d29f7b',
		BrazeSdkEndpoint: 'sdk.iad-05.braze.com',
		BrazeWithdrawalConfirmationCampaignId: '921fc091-222d-4ff7-afa4-f41595c4ef8a',
		BrazeWorkbooksBundlePlusOfferCanvasId: '2fcfb4c4-4383-4082-80b8-e370f029da61',
		BrazeWeightLossBoostCampaignId: 'f62c222b-f871-fad7-f2b3-3bf9bc7dc36d',
		BrazeMotivationBoostCampaignId: '0fc5087d-240a-44a8-ae94-eec224b5506a',
		BrazeSignInCodeCampaignId: '2d127673-0995-cb27-928a-a76c31233d54',
		BrazeDownloadScreenCampaignId: '350da713-032b-0932-e781-05a3c424a441',
		BrazeAssessmentCampaignId: '9ac2304e-c49a-478d-a881-8aa3ee886bc4',
		BrazeBodyReportCampaignId: 'd03e6f35-739f-4164-92df-731b491ee601',
		BrazeSignInConfirmEmailCampaignId: '874e3f7d-be4a-4cd1-b37c-2090260036d9',
		BrazeStepByStepCoursesAddExpCampaignId: 'b6c87dbe-f717-4d02-b5d9-a3420e0b93af',
		BrazeAssessmentFlowBodyReportCampaignId: 'f50a84f9-8c2d-4246-baf4-63d40443cfc0',
		BrazePrintableGuideCampaignId: 'a48482c8-7144-4fe3-839e-c864f319bab2',
		BrazePrintableGuideWalkingFCampaignId: 'f998cdb1-4dd9-4c11-b768-5e720122519b',
		BrazePrintableGuideTaiChiWalkingFCampaignId: 'c9d8b4ca-771c-475b-8e59-5b6796eb1c42',
		BrazeWaterFastingFCampaignId: '', // we don't have dev campaign id yet
		BrazeWaterFastingFNotALCampaignId: 'c9d8b4ca-771c-475b-8e59-5b6796eb1c42',
		BrazePrintableGuideTaiChiYogaMCampaignId: '', // we don't have dev campaign id yet
		BrazeGift100USDCampaignId: 'c9d8b4ca-771c-475b-8e59-5b6796eb1c42',
		BrazeWorkbooksTriggerCampaignId: 'c9d8b4ca-771c-475b-8e59-5b6796eb1c42',
		FstrAPIUrl: import.meta.env.VITE_FSTR_API_URL || 'https://rest.dev.fstr.app/v1',
		FstrUsersAPIUrl: import.meta.env.VITE_FSTR_USERS_API_URL || 'https://rest.dev.fstr.app/users-api/v1',
		FstrSyncAPIUrl: import.meta.env.VITE_FSTR_SYNC_API_URL || 'https://rest.dev.fstr.app/sync-api/v1',
		FstrSyncAPIUrlV2: import.meta.env.VITE_FSTR_SYNC_API_V2_URL || 'https://rest.dev.fstr.app/sync-api/v2',
		SimpleAPIUrl: import.meta.env.VITE_SIMPLE_API_URL || 'https://payment-api-dev.simple.life/',
		MarketingAPIUrl: import.meta.env.VITE_MARKETING_API_URL || 'https://martech-api.dev.fstr.app/api/public/v1',
		GeoAPIUrl: import.meta.env.VITE_GEO_API_URL || 'https://assets.simple.life/geo.json',
		FeatureFlagsUrl: 'https://configs.cdn-simple-life.com/content-api/dev/feature_flags.json',
		ApiLocalization: 'https://i18n.cdn-simple-life.com/dev/i18n/',
		AssetsPublicUrl: 'https://assets.simple.life/',
		AssessmentAPIUrl: import.meta.env.VITE_ASSESSMENT_API_URL || 'https://growth-rnd-dev.it1040.workers.dev',
		ExperimentsApiUrl: import.meta.env.VITE_EXPERIMENTS_API_URL || 'https://martech-experiments.dev.fstr.app',
		ExperimentsApiAuthToken: 'Lta2Tz5zKuOGwl4sXcBLMZm7DPZaEg3V',
		stripe_product_id: 'prod_GW5JdBN2r8HlOJ',
		stripe_introductory: 'prod_MYH1pNY399u6n7',
		stripe_cheap_and_short: 'prod_NuEdBJJQBl9WMO',
		stripe_cheap_and_short_1_month: 'prod_OlhTy9tPOtVIcQ',
		stripe_cheap_and_short_3_month: 'prod_OlhUuJspakGMsr',
		stripe_cheap_and_short_1_year: 'prod_OlhVOShdsHkhIL',
		stripe_cheap_and_short_upgrade_1_year: 'prod_OHOkEYGJklKFSE',
		stripe_cheap_and_short_upgrade_3_month: 'prod_ORsb2kz7jxwfqd',
		stripe_cheap_and_short_upgrade_6_month: 'prod_ORsagwcYh7PCmB',
		stripe_cheap_and_short_upgrade_9_month: 'prod_ORsYD4Y4VMNo4U',
		stripe_meal_plan_subscription: 'prod_NwPzO4k2Oydp1U',
		stripe_upgrade_on_year: 'prod_OHNV3cpO8RWy20',
		stripe_commitment_1_month: 'prod_PdMCBS2KG5xz6i',
		// If you're adding a new commitment plan, don't forget to process this case in PlanManagementCommitment.vue
		// and ask @payments-eng-team to add this plan to the commitment cancellation scenario
		auth0RedirectDomainsWhitelist: ['simple-web.dev.fstr.app'],
		BrazeWorkbookPurchaseCampaignId: '365b881f-59c3-45d4-b7b6-8d1bcda2277b',
	},

	production: {
		Auth0Domain: 'auth.simple-life-app.com',
		Auth0ClientId: '6zwnEFOjjAiacaUmZloxt4lhRzo68qm5',
		Auth0AudienceDomain: 'https://rest.simple.life',
		AbSmartlyApiHost: 'https://simple.absmartly.io',
		AbSmartlyApiKey: '2HkWTYAWpZGDabCrX_Dx4gAJpw-CF5j4QcZXLSSKxCpclQmido5k7qKMuZuu70zd',
		AmplitudePaltaWeb: '02714fe0df63e6f2d797930ed05998d2',
		GTMMainContainer: 'GTM-MNHMHJD',
		GTMActivityContainer: 'GTM-MSF5SXMW',
		GTMGLP1Container: 'GTM-59QQ9XRT',
		OnetrustSimpleLifeAppApiKey: 'f408777c-6bdf-4ff7-bfc6-6bdea2869b6e',
		OnetrustSimpleLifeApiKey: 'c264de99-8404-4220-bdb5-5d66776eeda0',
		FB: '871387013207297',
		AppleClientId: 'com.amapps.simple.web.signin',
		GoogleClientId: '500728569656-of3b8ost6fh8mghk0olr61kam77pjtpv.apps.googleusercontent.com',
		BrazeApiKey: '020304c8-bbbf-4043-8322-b454553bba4d',
		BrazeCanvasApiKey: 'cbe5e595-ce0f-4e22-ba6f-5ccdc0567951',
		BrazeCampaignApiKey: '3ea60a92-6ad9-4588-afe7-5ac2837e1a3f',
		BrazeSdkEndpoint: 'sdk.iad-05.braze.com',
		BrazeWithdrawalConfirmationCampaignId: 'bc3b9073-b4b5-4972-9848-2a516ef163e9',
		BrazeWorkbooksBundlePlusOfferCanvasId: '8da9878e-2d64-dad2-edc6-ea9a8eddca9c',
		BrazeWeightLossBoostCampaignId: 'c18c7174-d2c1-e071-c593-adadc61cd9a2',
		BrazeMotivationBoostCampaignId: '379a464f-fe69-4256-aa10-f0cbec4ef40c',
		BrazeDownloadScreenCampaignId: '82401ae1-7a49-4fc5-8672-fa3b491b9b01',
		BrazeSignInCodeCampaignId: 'fa3db25a-dc2f-48eb-b453-e7e1023f330d',
		BrazeAssessmentCampaignId: '19798a8d-617f-496d-b7dc-bb4df43764b0',
		BrazeBodyReportCampaignId: 'd369d956-701d-4771-8bf9-f3bf5043cba4',
		BrazeSignInConfirmEmailCampaignId: 'f8ccaa81-d295-4fc1-a5e5-d45d693fa927',
		BrazeStepByStepCoursesAddExpCampaignId: 'c0b68d0b-64b8-4b46-9407-80823f072741',
		BrazeAssessmentFlowBodyReportCampaignId: '417e6c28-2d0b-4045-a46b-97af2849543e',
		BrazePrintableGuideCampaignId: '998e5e15-8993-4094-9183-23642f581d43',
		BrazePrintableGuideWalkingFCampaignId: '57fc1963-790d-4e78-9ef0-bb4e9136708a',
		BrazePrintableGuideTaiChiWalkingFCampaignId: 'e62662e7-435d-4aab-a50b-6abf03e46662',
		BrazeWaterFastingFCampaignId: '7a22b140-2e11-45e0-b040-7aa2024c6047',
		BrazeWaterFastingFNotALCampaignId: 'e62662e7-435d-4aab-a50b-6abf03e46662',
		BrazeGift100USDCampaignId: 'e62662e7-435d-4aab-a50b-6abf03e46662',
		BrazeWorkbooksTriggerCampaignId: 'e62662e7-435d-4aab-a50b-6abf03e46662',
		BrazePrintableGuideTaiChiYogaMCampaignId: '123f3e8f-e16e-4f44-a936-918e1f5d9dbd',
		FstrAPIUrl: 'https://rest.simple.life/v1',
		FstrUsersAPIUrl: 'https://rest.simple.life/users-api/v1',
		FstrSyncAPIUrl: 'https://rest.simple.life/sync-api/v1',
		FstrSyncAPIUrlV2: 'https://rest.simple.life/sync-api/v2',
		SimpleAPIUrl: 'https://api.simple.life/',
		MarketingAPIUrl: 'https://martech-api.simple.life/api/public/v1',
		GeoAPIUrl: 'https://assets.simple.life/geo.json',
		FeatureFlagsUrl: 'https://configs.cdn-simple-life.com/content-api/feature_flags.json',
		ApiLocalization: 'https://i18n.cdn-simple-life.com/i18n/',
		AssetsPublicUrl: 'https://assets.simple.life/',
		AssessmentAPIUrl: 'https://cf-api.simple.life',
		ExperimentsApiUrl: 'https://martech-experiments.fstr.app',
		ExperimentsApiAuthToken: 'Lta2Tz5zKuOGwl4sXcBLMZm7DPZaEg3V',
		stripe_product_id: 'prod_GgA3GIwzX7x2Wx',
		stripe_introductory: 'prod_MYGmHi1IUfZbZT',
		stripe_cheap_and_short: 'prod_NuuPPCWqACFvaX',
		stripe_cheap_and_short_1_month: 'prod_OlhZHM6P3PcfQj',
		stripe_cheap_and_short_3_month: 'prod_OlhaZcr2PRJmIV',
		stripe_cheap_and_short_1_year: 'prod_Olhb5ZuzjBQXb2',
		stripe_cheap_and_short_upgrade_1_year: 'prod_OHOaIf5cgshVkT',
		stripe_cheap_and_short_upgrade_3_month: 'prod_ORsxDWFSvGgYRX',
		stripe_cheap_and_short_upgrade_6_month: 'prod_ORswLUtnySYgTl',
		stripe_cheap_and_short_upgrade_9_month: 'prod_ORsvyosF7jYq6x',
		stripe_meal_plan_subscription: 'prod_OAiQ8j7txPNmwG',
		stripe_upgrade_on_year: 'prod_OHhd5BgG2bvOBS',
		stripe_commitment_1_month: 'prod_PdMFm8biWA9eOw',
		auth0RedirectDomainsWhitelist: ['web.simple-life-app.com'],
		BrazeWorkbookPurchaseCampaignId: '65874eb3-5e02-c8d2-8aa5-a96298540e99',
	},
}

export default function getConfig(option) {
	if (ENV_HACKERONE) {
		if (option === 'StrapiCMS') {
			return config.production.OnboardingBuilderS3
		}

		return config.development[option]
	} else if (ENV_DEV_OR_STAGING) {
		if (option === 'OnetrustSimpleLifeAppApiKey') {
			return config.development.OnetrustSimpleLifeAppApiKey
		} else if (option === 'OnetrustSimpleLifeApiKey') {
			return config.development.OnetrustSimpleLifeApiKey
		}
	}

	if (Object.prototype.hasOwnProperty.call(config[ENV], option)) {
		return config[ENV][option]
	}

	return config.production[option]
}

// Also export as named for compatibility
export { getConfig as config }
